<template>
  <div class="panel has-bg">
    <div class="row">
      <div class="col-md-6">
        <h3>{{ $t('bearings.headlineBearingScheme') }}</h3>
      </div>
    </div>
    <div class="m-auto w-100">
      <div v-if="$i18n.locale === 'de'">
        <img
          v-if="holesCount == '0'"
          src="../../assets/img/abbildungen/lagerausbildung.jpg"
          :alt="$t('bearings.headlineBearingScheme')"
        />
        <img
          v-if="holesCount == '1'"
          src="../../assets/img/abbildungen/lagerausbildung-1bohrung.jpg"
          :alt="$t('bearings.headlineBearingScheme')"
        />
        <img
          v-if="holesCount == '2'"
          src="../../assets/img/abbildungen/lagerausbildung-2bohrungen.jpg"
          :alt="$t('bearings.headlineBearingScheme')"
        />
        <img
          v-if="holesCount == '3'"
          src="../../assets/img/abbildungen/lagerausbildung-3bohrungen.jpg"
          :alt="$t('bearings.headlineBearingScheme')"
        />
        <img
          v-if="holesCount == '4'"
          src="../../assets/img/abbildungen/lagerausbildung-4bohrungen.jpg"
          :alt="$t('bearings.headlineBearingScheme')"
        />
      </div>
      <div v-else>
        <img
          v-if="holesCount == '0'"
          src="../../assets/img/abbildungen/lagerausbildung-en.png"
          :alt="$t('bearings.headlineBearingScheme')"
        />
        <img
          v-if="holesCount == '1'"
          src="../../assets/img/abbildungen/lagerausbildung-1bohrung-en.png"
          :alt="$t('bearings.headlineBearingScheme')"
        />
        <img
          v-if="holesCount == '2'"
          src="../../assets/img/abbildungen/lagerausbildung-2bohrungen-en.png"
          :alt="$t('bearings.headlineBearingScheme')"
        />
        <img
          v-if="holesCount == '3'"
          src="../../assets/img/abbildungen/lagerausbildung-3bohrungen-en.png"
          :alt="$t('bearings.headlineBearingScheme')"
        />
        <img
          v-if="holesCount == '4'"
          src="../../assets/img/abbildungen/lagerausbildung-4bohrungen-en.png"
          :alt="$t('bearings.headlineBearingScheme')"
        />
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'FixedBearingsFormVisual',
  components: {
  },
  data() {
    return {
      showRotationAngles: false,
    };
  },
  computed: {
    schemeTypeOptions() {
      return Object.values(this.$dataOptionsHelper.getSchemeTypeOptions(this.$i18n));
    },
    holesCount() {
      return this.$outputHelper.convertToInteger(this.$store.state.fixedBearingHolesCount);
    },
    schemeType: {
      get() {
        return this.$store.state.fixedBearingSchemeType;
      },
      set(value) {
        this.$store.commit('fixedBearingSchemeType', value);
      },
    },
  },
};
</script>
